// eslint-disable-next-line import/named
import styled from "../../__compat__/styled-components/main.entry.mjs.mjs";
import { injectSpacing } from "../../api/spacing/injectSpacing.mjs.mjs";
import { injectTypography } from "../../utils/injectTypography.mjs.mjs";
import { injectOSXFontSmoothing } from "../../utils/injectOSXFontSmoothing.mjs.mjs";
import { getEasing } from "../../utils/getEasing.mjs.mjs";
function isHeadline(variant) {
    return [
        'order1',
        'order2',
        'order3',
        'order4',
        'display1',
        'display2',
    ].includes(variant);
}
function getVariantColor(variant, theme) {
    switch (variant) {
        case 'order1':
        case 'display1':
        case 'display2':
            return theme.colors.ui.primary;
        default:
            return theme.colors.ui.secondary;
    }
}
function getCopyTint(tint, theme) {
    if (tint === 'secondary') {
        return theme.colors.ui.tertiary;
    }
    return theme.colors.ui.secondary;
}
export const StyledText = styled.span.withConfig({ displayName: "auir-611444a-StyledText", componentId: "auir-611444a-1i3s23y" }) `
  margin: 0;

  color: var(
    ${(props) => props.tint
    ? getCopyTint(props.tint, props.theme)
    : getVariantColor(props.variant, props.theme)}
  );
  font-weight: var(${(props) => props.theme.fontWeights[props.weight]});
  font-style: normal;
  letter-spacing: ${(props) => isHeadline(props.variant) && '-0.015em'};
  text-decoration: none;

  ${(props) => injectTypography(props, props.variant)}

  ${injectOSXFontSmoothing(true)}
  ${injectSpacing('margin')}

  @media (max-width: 439px) {
    hyphens: auto;
    word-break: break-word;
  }

  /* Prevent italic styles on nested elements */
  i,
  em {
    font-style: inherit;
  }

  a {
    padding-bottom: 0.06125em;

    color: inherit;
    font-weight: var(${(props) => props.theme.fontWeights.bold});
    text-decoration: none;

    border-bottom: 1px solid
      var(${(props) => props.theme.colors.interaction.primary.default});

    transition: 250ms var(${getEasing});
    transition-property: color border-color;

    &:focus {
      color: var(${(props) => props.theme.colors.interaction.primary.focus});

      border-bottom-color: var(
        ${(props) => props.theme.colors.interaction.primary.focus}
      );
    }

    &:hover {
      color: var(${(props) => props.theme.colors.interaction.primary.hover});

      border-bottom-color: var(
        ${(props) => props.theme.colors.interaction.primary.hover}
      );
    }

    @media (max-width: 439px) {
      hyphens: auto;
    }
  }

  sup {
    vertical-align: 0.68em;
  }

  sub {
    vertical-align: -0.275em;
  }

  sup,
  sub {
    font-size: 0.583em;

    a {
      border-bottom: none;
    }
  }
`;
//# sourceMappingURL=Text.styles.mjs.mjs.map